module.exports = __webpack_public_path__ + "img/CLOSED_RED.fa1f4226.svg";